import { ReactNode } from "react";
import { Button } from "../../../design/button";
import { Heading } from "../../../design/heading";
import { Text } from "../../../design/text";
import CreateDocumentButton from "../../../components/CreateDocumentButton/CreateDocumentButton";

interface CardItem {
  icon: React.ReactNode;
  title: string;
  description: string;
  trigger?: ReactNode;
}

const cards: CardItem[] = [
  {
    icon: <span>📝</span>,
    title: "Draft Your Parenting Plan",
    description:
      "Work with your attorney or coach to create a detailed parenting plan that supports stability and meets court standards.",
    trigger: (
      <CreateDocumentButton type="parenting_plan" className="w-full">
        Start Plan
      </CreateDocumentButton>
    ),
  },
];

const DocumentRecommendationsCard: React.FC = () => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {cards.map((card, index) => (
        <div
          key={index}
          className="flex flex-col justify-between p-6 transition bg-white border shadow-sm rounded-xl hover:shadow-md"
        >
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
              <div className="text-2xl">{card.icon}</div>
              {/* Optionally a close (X) button here */}
            </div>
            <Heading>{card.title}</Heading>
            <Text>{card.description}</Text>
          </div>
          {card.trigger && <div className="mt-4">{card.trigger}</div>}
        </div>
      ))}
    </div>
  );
};

export default DocumentRecommendationsCard;
